import { LOGO_ICON, LOGO } from "@calcom/lib/constants";

export default function Logo({ small, icon }: { small?: boolean; icon?: boolean }) {
  return (
    <h3 className="logo inline">
      <strong>
        {icon ? (
          <img className="w-12" alt="logo" title="logo" src={LOGO_ICON} />
        ) : (
          <img className={small ? "h-4 w-auto" : "h-5 w-auto"} alt="logo" title="logo" src={LOGO} />
        )}
      </strong>
    </h3>
  );
}
